import { FaLayerGroup, FaStoreAlt, FaUserCog, FaUsersCog, FaWallet } from 'react-icons/fa'
import { LuLayoutDashboard } from 'react-icons/lu'
import {
    RiCustomerService2Fill,
    RiFileList3Fill,
    RiShoppingCartFill,
    RiMessageLine,
    RiBankFill,
    RiUserSettingsLine,
    RiShieldCheckFill,
} from 'react-icons/ri'
import { TbShoppingCartCog } from 'react-icons/tb'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/user',
                text: 'Dashboard',
                permission: 'dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/user/roles'],
                url: '/user/roles',
                text: 'Roles',
                permission: 'roles.index',
                icon: <FaUserCog />,
            },
            {
                active: ['/user/users'],
                url: '/user/users',
                text: 'Users',
                permission: 'users.index',
                icon: <FaUsersCog />,
            },
            {
                active: ['/user/customers'],
                url: '/user/customers',
                text: 'Customers',
                permission: 'customers.index',
                icon: <FaLayerGroup />,
            },
            {
                active: ['/user/service-staffs'],
                url: '/user/service-staffs',
                text: 'Service Staffs',
                permission: 'service_staffs.index',
                icon: <RiCustomerService2Fill />,
            },
            {
                active: ['/user/stores'],
                url: '/user/stores',
                text: 'Stores',
                permission: 'stores.index',
                icon: <FaStoreAlt />,
            },
            {
                active: ['/user/order-requests'],
                url: '/user/order-requests',
                text: 'Order Requests',
                permission: 'order_requests.index',
                icon: <RiFileList3Fill />,
            },
            {
                active: ['/user/orders'],
                url: '/user/orders',
                text: 'Orders',
                permission: 'orders.index',
                icon: <RiShoppingCartFill />,
            },
            {
                active: ['/user/order-progress'],
                url: '/user/order-progress',
                text: 'Work In Progress',
                permission: 'progress.index',
                icon: <TbShoppingCartCog />,
            },
            {
                active: ['/user/warranty-services'],
                url: '/user/warranty-services',
                text: 'Warranty Services',
                permission: 'warranty_services.index',
                icon: <RiShieldCheckFill />,
            },
            {
                active: ['/user/customer-requests'],
                url: '/user/customer-requests',
                text: 'Complaint Requests',
                permission: 'customer_requests.index',
                icon: <RiMessageLine />,
            },
            {
                active: ['/user/wallets'],
                url: '/user/wallets',
                text: 'Wallets',
                permission: 'wallets.index',
                icon: <FaWallet />,
            },
            {
                active: ['/user/withdrawal-requests'],
                url: '/user/withdrawal-requests',
                text: 'Withdrawal Requests',
                permission: 'withdrawal_requests.index',
                icon: <RiBankFill />,
            },
            {
                active: [
                    '/user/machine-types',
                    '/user/machines',
                    '/user/terms',
                    '/user/festival-offers',
                    '/user/service-inspections',
                    '/user/machine-demos',
                ],
                text: 'Master Data',
                icon: <RiUserSettingsLine />,
                child: [
                    {
                        active: ['/user/machine-types'],
                        url: '/user/machine-types',
                        text: 'Machine Types',
                        permission: 'machine_types.index',
                    },
                    {
                        active: ['/user/machines'],
                        url: '/user/machines',
                        text: 'Machines',
                        permission: 'machines.index',
                    },
                    {
                        active: ['/user/terms'],
                        url: '/user/terms',
                        text: 'Terms',
                        permission: 'terms.index',
                    },
                    {
                        active: ['/user/festival-offers'],
                        url: '/user/festival-offers',
                        text: 'Festival Offers',
                        permission: 'festival_offers.index',
                    },
                    {
                        active: ['/user/service-inspections'],
                        url: '/user/service-inspections',
                        text: 'Service Inspection',
                        permission: 'service_inspections.index',
                    },
                    {
                        active: ['/user/machine-demos'],
                        url: '/user/machine-demos',
                        text: 'Machine Demo',
                        permission: 'machine_demos.index',
                    },
                ],
            },
        ],
    },
]

export default appRoutes
